import { useEffect, useRef } from "react";
import {
	matchPath,
	type Params,
	type Location as RouterLocation,
	useLocation,
	useNavigate,
	useParams,
} from "react-router-dom";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { device } from "web_myplann/Utils/device";
import { WebViewMessageTypes } from "web_myplann/Utils/WebViewModel";

const EXIT_ROUTES = [
	Routing.Portfolio.PortfolioTabs.path(),
	Routing.Portfolio.PortfolioList.path(),
	Routing.Portfolio.DocumentsList.path(),
	Routing.ActivitiesList.path(),
];

export const useNavigateBack = () => {
	const navigate = useNavigate();

	const location = useLocation();
	const params = useParams();

	const locationRef = useRef<{
		location: RouterLocation;
		params: Readonly<Params<string>>;
	}>({ location, params });

	if (
		locationRef.current.location !== location ||
		locationRef.current.params !== params
	) {
		locationRef.current = { location, params };
	}

	useEffect(() => {
		const messageListener = (nativeEvent: MessageEvent) => {
			const currentLocation = locationRef.current;

			if (nativeEvent.data.type === WebViewMessageTypes.NAVIGATE_BACK_REQUEST) {
				const isExitRoute = EXIT_ROUTES.some(
					(route) =>
						matchPath(route, currentLocation.location.pathname) !== null,
				);

				if (isExitRoute) {
					device.navigateBackRequest();
					return;
				}

				navigate(-1);
			}
		};

		window.addEventListener("message", messageListener);
		return () => {
			window.removeEventListener("message", messageListener);
		};
	}, [navigate, locationRef]);
};
